import styled from "styled-components";
import colors from "assets/scss/colors.scss";

const FooterWrapper = styled.div`
  .white {
    fontsize: 2em;
    color: #6B47F5;
  }
  .back,.button-next{
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
    .flip{
      transform: scaleX(-1);
    }
  }
  .back {
    background: #fff !important;
    border: 1px solid ${colors["bright-purple"]} !important;
    color: ${colors["bright-purple"]} !important;
  }
  .back-bsf {
    border: 1px solid var(--color-green-bsf) !important;
    color: var(--color-green-bsf) !important;
  }
  .back-stc {
    border: 1px solid var(--color-purple-stc) !important;
    color: var(--color-purple-stc) !important;
  }
  .back-lucid {
    border: 1px solid var(--color-black-lucid) !important;
    color: var(--color-black-lucid) !important;
  }
  .back-cartrust {
    border: 1px solid var( --color-primary-cartrust) !important;
    color: var( --color-primary-cartrust) !important;
  }
  .back-syarah {
    border: 1px solid var( --color-primary-syarah) !important;
    color: var( --color-primary-syarah) !important;
  }
  .back-snb {
    border: 1px solid var(--color-green-snb) !important;
    color: var(--color-green-snb) !important;
  }
  .back-alnaghi {
    border: 1px solid var(--color-alnaghi) !important;
    color: var(--color-alnaghi) !important;
  }
  .back-petromin {
    border: 1px solid var( --color-primary-petromin) !important;
    color: var( --color-primary-petromin) !important;
  }


  .float-right {
    float: right;
  }

  .orange{
    color: #6B47F5 !important;
  }
  .text{
font-style: normal;
font-weight: 400;
font-size: 16px;

  }
  .bottom-box-summary {
    z-index: 10;
    position: fixed;
    right: 45px;
    bottom: 0;
    text-align: initial;
    padding: 18px 24px;
    background: #ffffff;
    box-shadow: 0px 35px 60px rgb(9 30 66 / 15%);
    border-radius: 12px 12px 0px 0px;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: initial;
  }
  .bottom-box-summary-rtl {
    z-index: 10;
    left: 45px;
    position: fixed;
    bottom: 0;
    width: 69%;
    text-align: right;
    padding: 20px 18px 18px 18px;
    background: #ffffff;
    box-shadow: 0px 35px 60px rgb(9 30 66 / 15%);
    border-radius: 12px 12px 0px 0px;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: right;
  }
  .heading-summ {
    font-weight: 800;
    font-size: 1.2rem;
    line-height: 120%;
    color: #4c565c;
  }
  .sum-tab-left {
    font-weight: 800;
    font-size: 1rem;
    text-align: right;
    span {
      font-weight: 400;
      font-size: 0.65rem;
    }
  }
  .table {
    font-size: 1rem;
    font-weight: 400;
  }
  .bottom-box {
    position: fixed;
    right: 45px;
    bottom: 0;
    width: 69%;
    text-align: initial;
    padding: 18px 24px;
    background: #ffffff;
    box-shadow: 0px 35px 60px rgba(9, 30, 66, 0.15);
    border-radius: 12px 12px 0px 0px;
    justify-content: space-between;
    align-items: center;
  }
  .bottom-box-rtl {
    position: fixed;
    left: 41px;
    bottom: 0;
    width: 68%;
    text-align: initial;
    padding: 18px 24px;
    background: #ffffff;
    box-shadow: 0px 35px 60px rgba(9, 30, 66, 0.15);
    border-radius: 12px 12px 0px 0px;
    justify-content: space-between;
    align-items: center;
  }
  .p-button:focus {
    box-shadow: none;
  }
  .button-next {
    padding: 0px 24px 0px 24px;
    height: 50px;
    background: ${colors["bright-purple"]} !important;
    border-radius: 8px;
    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 16px;
    color: #ffffff;
  }
  .button-next-bsf {
    background: var(--color-green-bsf) !important;
  }
  .button-next-stc {
    background: var(--color-purple-stc) !important;
  }
  .button-next-lucid {
    background: var(--color-black-lucid) !important;
  }
  .button-next-cartrust {
    background: var(--color-primary-cartrust) !important;
  }
  .button-next-syarah {
    background: var(--color-primary-syarah) !important;
  }
  .button-next-snb {
    background: var(--color-green-snb) !important;
  }
  .button-next-alnaghi {
    background: var(--color-alnaghi) !important;
  }
  .button-next-petromin {
    background: var(--color-primary-petromin) !important;
  }


  .p-button {
    background: #4F46E5;
  }
  .vector-button,
  .vector-button:hover {
    background: #fff !important;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border: 1px solid #fff;
    border-radius: 8px;
    width: 54px;
    height: 47px;
    align-items: center;
    justify-content: center;
  }
  .summary {
    font-weight: 400;
    font-size: 0.9rem;
    line-height: 14px;
    color: #4c565c;
    padding-top: 1px;
    padding-bottom: 4px;
  }
  .sar {
    font-weight: 800;
    font-size: 1.8rem;
    line-height: 28px;
    color: #262626;
    span {
      font-weight: 500;
      font-size: 0.9rem;
      line-height: 14px;
      color: #4c565c;
      padding-left: 4px;
    }
  }
  .sar-rtl {
    font-weight: 800;
    font-size: 1.8rem;
    line-height: 28px;
    color: #262626;
    span {
      font-weight: 500;
      font-size: 0.9rem;
      line-height: 14px;
      color: #4c565c;
      padding-left: 4px;
    }
  }
  .desktop-section {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  .img-arrow-rtl {
    position: absolute;
    left: -10px;
    top: 23px;
    transform: rotateZ(180deg);
  }
  .bottom-box-rtl .button-next {
    padding: 0px 30px 0px 16px;
  }
  @media only screen and (max-width: 660px) {
    .bottom-box-rtl {
      width: 100%;
      left: 0;
    }
    .bottom-box {
      background: #ffffff;
      box-shadow: 0px -10px 33px rgb(9 30 66 / 6%);
      right: 0px;
      bottom: 0;
      width: 100%;
    }
    .bottom-box-summary {
      background: #ffffff;
      box-shadow: 0px -10px 33px rgb(9 30 66 / 6%);
      right: 0px;
      bottom: 0;
      width: 100%;
      // z-index: 99999999;
    }
    .bottom-box-summary-rtl {
      width: 100%;
      left: 0;
    }
    .grow-button {
      flex-grow: 1;
    }
    .vector-button,
    .vector-button:hover {
      width: 54px;
      height: 54px;
      background: #FFF;
      border-radius: 8px;
      border: 1px solid #fdf1e5;
      .orange {
        width: auto;
        height: 27px;
        color: #9aa2af;
        opacity: 0.5;
      }
    }
    .button-save {
      padding: 0 24px;
      height: 54px;
      background: ${colors["bright-purple"]} !important;
      border-radius: 8px;
      border: 1px solid ${colors["bright-purple"]};

      font-style: normal;
      font-weight: 400;
      font-size: 1rem;
      line-height: 16px;
      color: #ffffff;
      width: 100%;
      display: block;
    }
    .button-save-bsf {
      background: var(--color-green-bsf) !important;
    }
    .button-save-cartrust {
      background: var(--color-primary-cartrust) !important;
      border:0;
    }
    .button-save-syarah {
      background: var(--color-primary-syarah) !important;
      border:0;
    }
    .button-save-snb {
      background: var(--color-green-snb) !important;
    }
    .button-save-alnaghi {
      background: var(--color-alnaghi) !important;
    }
    .button-save-petromin {
      background: var(--color-primary-petromin) !important;
      border:0;
    }

    .rotate-button {
      width: 54px;
      height: 54px;
      background: white !important;
      color: white;
      border: none;
      border-radius: 8px;
      margin-left: 15px;
      margin-right: 15px;
    }
    .desktop-section {
      display: none;
    }

    .p-button:enabled:active,
    .p-button:not(button):not(a):not(.p-disabled):active {
      background: none;
      color: #ffffff;
      border-color: none;
    }
    .p-button:enabled:hover,
    .p-button:not(button):not(a):not(.p-disabled):hover {
      background: none;
      color: #fff;
      border-color: none;
    }
  }
  .back-mb{
    background: #F1F5F8 !important;
    border: none;
  }

  .mobile-section {
    width: 100%;
    .button_wrapper{
      padding: 1.25rem;
      background: #fff;
    }
  }

  .summary_mobile{
    width: 100%;
    justify-content: center;
    align-items: center;
    margin: -1px auto;
    display: flex;
    // flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 4px 24px;
    gap: 4px;
    background:white;
    // width: 350px;
    height: 50px;

    /* White */

    // background: rgba(255,255,255,0.6);
    border-radius: 10px 10px 0px 0px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;

    span{
      display: inline-block
      font-style: normal;
      font-weight: 400;
      line-height: 1rem;
      color: #1A1C1F;
    }
    .price_value{
      font-weight: 900;
    }

    .rotate{
      transform: rotate(180deg);
    }

    &.opened{
      background: #fff;
      border-radius: 0;
    }
  }
  .summary_wrapper{
    border-radius: 10px 10px 0px 0px;
    padding: 2rem 1rem 0.5rem;
    background: #fff;
    width: 90%;
    margin: 0 auto;
    @media(max-width: 767px){
      max-height: calc(100vh - 150px);
      overflow: auto;
    }
  }


  @media screen and (min-width: 765px) and (max-width: 1200px) {
    .bottom-box {
      width: 80%;
      right: 81px;
    }
    .bottom-box-summary {
      width: 80% !important;
      right: 81px;
    }
  }
  @media screen and (min-width: 1000px) and (max-width: 1200px) {
    .bottom-box {
      width: 80%;
      right: 114px;
    }
    .bottom-box-summary {
      width: 80%;
      right: 114px;
    }
  }

  @media screen and (max-width: 576px) {
    .bottom-box-summary, .bottom-box-summary-rtl {
      background: transparent;
      box-shadow: none;
      padding: 0;
    }
  }
    
  &.ar{
    .back img{
      transform: rotate(180deg);
    }
    .sum-tab-left{
      text-align: left
    }
  }
  .overlaySummary{
    background-color: transparent;
    left: 0;
    position: absolute;
    top: 0;
    height:  calc(100vh + 158px);
    width: 100%;
  }
`;

export default FooterWrapper;
